import type { WrappedFieldProps } from "redux-form";

import { assertUnreachable } from "@js/utils";

import { RATE_FIELDS_KEYS } from "./constants";

export const getFieldsToCheckMeta = (
  paymentType: EnumType<typeof ENUMS.JobPaymentType>,
  fields: WrappedFieldProps[],
) => {
  const necessaryFields = mapPaymentTypeToRequiredFieldsKeys(paymentType);

  const filtered = fields.filter((field) => {
    return (necessaryFields as string[]).includes(field.input.name);
  });

  return filtered;
};

const mapPaymentTypeToRequiredFieldsKeys = (
  paymentType: EnumType<typeof ENUMS.JobPaymentType>,
) => {
  let necessaryFields: (keyof typeof RATE_FIELDS_KEYS)[] = [
    RATE_FIELDS_KEYS.min_rate,
    RATE_FIELDS_KEYS.max_rate,
    RATE_FIELDS_KEYS.custom_min_rate,
    RATE_FIELDS_KEYS.custom_max_rate,
    RATE_FIELDS_KEYS.hourly_rate,
    RATE_FIELDS_KEYS.payment_type,
    RATE_FIELDS_KEYS.talent_invoice_editing_disabled,
  ];

  switch (paymentType) {
    case ENUMS.JobPaymentType.HOURLY: {
      break;
    }
    case ENUMS.JobPaymentType.ANNUAL: {
      necessaryFields = [
        RATE_FIELDS_KEYS.min_annual_rate,
        RATE_FIELDS_KEYS.max_annual_rate,
        RATE_FIELDS_KEYS.payment_type,
        RATE_FIELDS_KEYS.talent_invoice_editing_disabled,
      ];
      break;
    }
    case ENUMS.JobPaymentType.MONTHLY: {
      necessaryFields = [
        RATE_FIELDS_KEYS.min_monthly_rate,
        RATE_FIELDS_KEYS.max_monthly_rate,
        RATE_FIELDS_KEYS.payment_type,
        RATE_FIELDS_KEYS.talent_invoice_editing_disabled,
      ];
      break;
    }
    case ENUMS.JobPaymentType.FIXED_PRICE:
    case ENUMS.JobPaymentType.PER_TASK:
    case ENUMS.JobPaymentType.FIXED_PROJECT: {
      necessaryFields = [
        RATE_FIELDS_KEYS.fixed_rate,
        RATE_FIELDS_KEYS.payment_type,
        RATE_FIELDS_KEYS.talent_invoice_editing_disabled,
      ];
      break;
    }
    default: {
      assertUnreachable(paymentType);
      break;
    }
  }

  return necessaryFields;
};
